/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-green/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Form from "saur_ui_library/src/Atoms/Input/Form/Form";
import Button from "saur_ui_library/src/Atoms/Input/Button/Button";
import Word from "saur_ui_library/src/Atoms/Word/Word";
import ErrorParameter from "../../components/common/ErrorParameter";
import { InputNumber } from "primereact/inputnumber";
import { SeuilsApi } from "../../utils/api";
import { loaderDataComponent } from "../../utils/helper";

declare type BreakProps = {
  id?: string;
  mainInstallCode: string;
};

const FormOverFlow = ({ mainInstallCode }: BreakProps) => {
  //form variable
  const [error, setError] = useState(false);
  const toast = useRef<any>(null);
  const [form, setForm] = React.useState<any>(null);
  const [data, setData] = React.useState<any>(null);
  const [showPlaceholder, setShowPlaceholder] = useState(false);
  const [loading, setLoading] = useState(false);

  //get api data
  const getThresholds = async () => {
    setLoading(true);
    try {
      const response = await SeuilsApi.getSeuilsOverflow(mainInstallCode);
      setData(response.data);
      setForm([
        {
          alert: {
            title: "Seuil d'alerte",
            value: response.data.alert,
          },
        },
        {
          vigilance: {
            title: "Seuil de vigilance",
            value: response.data.vigilance,
          },
        },
      ]);
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getThresholds();
  }, []);

  const updateSeuil = (propertyName, value) => {
    setForm((prevSeuils) =>
      prevSeuils.map((element) =>
        element[propertyName]
          ? {
              ...element,
              [propertyName]: {
                ...element[propertyName],
                value: value,
              },
            }
          : element
      )
    );
  };

  const ShowSeuils = () => {
    let seuilContent: any = [];
    form.forEach((element: object, i: number) => {
      const propertyName: string = Object.keys(element)[0];
      seuilContent.push(
        <div id={"seuil-" + propertyName} key={i}>
          {form ? (
            <>
              <Container className="blueline"></Container>
              <Container className="variableBody">
                <Word
                  variant="span"
                  textStyle="normalBold"
                  value={element[propertyName].title}
                  className="variable-min"
                />
                <InputNumber
                  className="seuil-input"
                  id="input-seuil-min"
                  value={element[propertyName].value}
                  onValueChange={(e: any) => {
                    if (e.value === null) {
                      setShowPlaceholder(true);
                    }
                    updateSeuil(propertyName, e.value);
                  }}
                  min={0}
                  max={100}
                  mode={"decimal"}
                  maxFractionDigits={1}
                  minFractionDigits={1}
                  placeholder={(showPlaceholder === true || element[propertyName].value === null) ? "Non renseigné" : undefined}
                />
              </Container>
            </>
          ) : null}
        </div>
      );
    });
    return <>{seuilContent}</>;
  };

  //api value and form data
  const handleOnSubmit = async () => {
    setLoading(true);
    try {
      const dataUpdated = {...data, alert: form[0].alert.value, vigilance: form[1].vigilance.value};
      delete dataUpdated['createdAt'];
      delete dataUpdated['updatedAt'];
      const response = await SeuilsApi.updateSeuilsOverflow(dataUpdated);
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: 'Succès',
            detail: 'Données de paramètres enregistrées',
            life: 5000,
          });
        }
    } catch (e) {
      toast.current?.show({
        severity: "error",
        summary: "Erreur",
        detail:
          "Les données de paramètres n'ont pas pu être enregistrées. Veuillez réessayer",
        life: 7000,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container
      automatedTestId="form-overFlow-global-container"
      className="form-overFlow-global-container sds-reset-style"
    >
      <Styles />
      <Toast ref={toast} />
      <Form className="overFlowForm" onSubmit={handleOnSubmit}>
        <Container className="form-overFlow-global-content">
          <Container className="form-overFlow-showed">
            {form !== null && ShowSeuils()}
          </Container>
        </Container>
        <Container>
          {loaderDataComponent(loading)}
          {loading === false && <StyledSectionButton>
            <Button
              automatedTestId="btn-overFlow-validation"
              className="param-btn"
              mode="plain"
            >
              <Word
                variant="span"
                textStyle="normalBold"
                value="Enregistrer les modifications"
              />
            </Button>
          </StyledSectionButton>}
        </Container>
      </Form>
      {error ? (
        <ErrorParameter
          message="une erreur s'est produite. Veuillez réessayer"
          title=""
          IsVisible={error}
        />
      ) : null}
    </Container>
  );
}
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  .param-btn {
    margin-top: 50px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }
`;

const Styles = createGlobalStyle`

.form-overFlow-global-container.sds-reset-style{
  .pi{
    font-family: 'primeicons';    
  }
  align-self: center;
  .overFlowForm{
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    .blueline{
    border: 0.5px solid #008BD2;
    background-color:  #008BD2;
    width: 30vh;
    align-self: center;   
    margin-top: 20px;
    margin-bottom: 10px;
  }
  
  .variable-title,.variable-subtitle{
    text-align: center;
  }
  .variable-min,.variable-max{
    line-height:6;
    width: 15vh;
    text-align: center;
  }
  .variableBody{
    flex-direction: row;
    align-self: center;
    justify-content: center;
  }
  input.p-inputtext.p-component.p-inputnumber-input{
    background-color: #FFFFFF;
    border: 1px solid #CCE8F6;
    border-radius: 5px;
    width: 95px;
    height: 43px;
    text-align: center;
    margin-left:10px;
    margin-top:20px;
    margin-bottom:20px;
    margin-right:20px;
  }
}
.form-overFlow-global-content{
 flex-direction: row;   
}
.form-overFlow-showed{
 flex-direction: column;   
 margin-left: auto;
 margin-right: auto;
 .hide-add-overFlow{
   display:none;
 }
}

}
`;

export default FormOverFlow;
